// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"57daa1ad","139":"57247240","195":"b2943e94","819":"60d00c9d"}[chunkId] + ".chunk.js";
};